import { useContext } from 'react';
import {
  FormSection,
  Layout,
  ButtonContainer,
  Button,
  Checkbox,
} from '@vwfs-bronson/bronson-react';
import { WizardConext } from '../../../../contexts/WizardContext';
import { useSummary } from '../../../../hooks/useSummary';
import { useLocationVehicle } from '../../../../hooks/useLocationVehicle';

export const SeguroDocs = () => {
  const { download, setdownload, isDirty, setIsSeguroDocsMounted } =
    useContext(WizardConext);
  const { selectedSeguroAutoStandAlone, selectedResumeOffers } = useSummary();
  const locationVehicle = useLocationVehicle();

  const offersSeguros =
    selectedResumeOffers?.filter(
      (x) =>
        x.AdditionalProducts?.Servicios?.filter(
          (v) =>
            v.CodigoServicio === 'SE' ||
            v.CodigoServicio === 'SR' ||
            v.CodigoServicio === 'SA',
        ).length > 0,
    ).length > 0;

  if (!offersSeguros && !selectedSeguroAutoStandAlone?.SeguroContratado) {
    return null;
  } else {
    setIsSeguroDocsMounted(true);
  }

  const handleSetDownload = (e) => {
    setdownload(e);
  };
  const GetDocument = (lang) => {
    const SA = selectedResumeOffers?.map(
      (x) =>
        x.AdditionalProducts?.Servicios?.filter(
          (v) => v.CodigoServicio === 'SA',
        ).length > 0,
    );
    console.log('selectedResumeOffers', JSON.stringify(selectedResumeOffers));
    console.log('SA', JSON.stringify(SA));
    onButtonClick(
      `./assets/Seguros/${lang === 'es' ? 'Castellano' : 'Catalan'}/Nota_Informativa.pdf`,
      'Nota_Informativa.pdf',
    );
    if (
      (SA && SA.length > 0) ||
      (selectedSeguroAutoStandAlone &&
        selectedSeguroAutoStandAlone.SeguroContratado)
    ) {
      let companyCode = selectedResumeOffers[0].CompanyCodeSABundle;

      if (
        (selectedSeguroAutoStandAlone &&
          selectedSeguroAutoStandAlone.SeguroContratado) ||
        companyCode === '0070'
      )
        onButtonClick(
          `./assets/Seguros/${lang === 'es' ? 'Castellano' : 'Catalan'}/Seguros_Zurich.pdf`,
          'Seguros_Zurich.pdf',
        );
      if (companyCode === '0038')
        onButtonClick(
          `./assets/Seguros/${lang === 'es' ? 'Castellano' : 'Catalan'}/Seguros_Mapfre.pdf`,
          'Seguros_Mapfre.pdf',
        );
      if (companyCode === '0003')
        onButtonClick(
          `./assets/Seguros/${lang === 'es' ? 'Castellano' : 'Catalan'}/Seguros_Mutua.pdf`,
          'Seguros_Mutua.pdf',
        );
    }

    const SE = selectedResumeOffers?.map((x) => {
      return x.AdditionalProducts?.Servicios?.filter(
        (v) => v.CodigoServicio === 'SE',
      );
    });
    if (SE && SE.length > 0) {
      const dateNow = new Date();
      const dateChangePPI = new Date(import.meta.env.VITE_APP_DATE_CHANGE_PPI_TEMPLATE);
      const oldFileName = 'Seguros_PPI_OLD.pdf';
      const newFileName = 'Seguros_PPI.pdf';
      const fileName = dateNow >= dateChangePPI ? newFileName : oldFileName;

      onButtonClick(
        `./assets/Seguros/${lang === 'es' ? 'Castellano' : 'Catalan'}/${fileName}`,
        'Seguros_PPI.pdf',
      );
    }

    const SR = selectedResumeOffers?.filter(
        (x) => x.AdditionalProducts?.Servicios?.some((v) => v.CodigoServicio === "SR")
    );
    if (SR && SR.length > 0) {
        let stringToDownload = "";
        // let hasCodigoCoberturaL = SR?.some(
        //     (offer) => offer.addicionalProdsList?.some(
        //         (prod) => prod.CodigoCobertura === "L"
        //     ),
        // );
        // stringToDownload = hasCodigoCoberturaL ? "IPID_Seguro_Proteccion_movilidad" : "Seguro_Retirada_Carnet"
        stringToDownload = "IPID_Seguro_Proteccion_movilidad"
        const fileName = `${stringToDownload}.pdf`
        const filePath = `./assets/Seguros/${lang === "es" ? "Castellano" : "Catalan"}/${fileName}` 
        
        onButtonClick(filePath,fileName);
    }
    setdownload(true);
  };
  const onButtonClick = (pdfUrl, fileName) => {
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = fileName; // specify the filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const hasError = !download && isDirty;

  return (
    <Layout.Item className="u-mt-small">
      <FormSection
        defaultOpen={true}
        subtitle={''}
        className="u-mb-small"
        title={'Documentos Seguros'}
      >
        <ButtonContainer center>
          <Button onClick={() => GetDocument('es')}>Castellano</Button>
          {!locationVehicle.IsCanarias && (
            <Button onClick={() => GetDocument('ct')}>Catalán</Button>)}
        </ButtonContainer>
        <Checkbox
          className="u-mt-small"
          name="checkbox-demo"
          value={download}
          checked={download}
          onChange={(e) => handleSetDownload(e.target.checked ? true : false)}
          {...(hasError ? { error: true } : {})}
        >
          Entrega Nota Previa Informativa del Mediador
        </Checkbox>
      </FormSection>
    </Layout.Item>
  );
};
